import { motion } from "framer-motion";
import { MaskLine, EASE } from "../lib/motion";

export default function PageHero({ overline, title, subtitle }) {
  return (
    <section className="relative overflow-hidden border-b border-white/10 pt-36 pb-16 md:pt-44 md:pb-24">
      <div className="absolute inset-0 z-0 bg-[radial-gradient(ellipse_at_top_left,_rgba(37,99,235,0.18),_transparent_55%)]" />
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.15, duration: 0.7 }}
          className="mb-6 text-xs md:text-sm uppercase tracking-[0.3em] font-bold text-accent"
        >
          {overline}
        </motion.p>
        <h1 className="font-display text-5xl font-black leading-[0.92] tracking-tighter md:text-7xl lg:text-8xl">
          <MaskLine delay={0.25}>{title}</MaskLine>
        </h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.7, ease: EASE }}
            className="mt-8 max-w-2xl text-base md:text-lg text-neutral-300 leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
